import React, { useEffect, useState } from "react";
import "screens/Landpage/landpage.css";
import "./colorir.css";
import Cabecalho from "components/LandpageNova/Cabecalho";
import Rodape from "components/LandpageNova/Rodape";
import AvisoNavegadorApp, { tirarMarcaDoEndereco } from "components/AvisoNavegadorApp";
import { FOLHA_IMAGEM, FOLHA_NOME, FOLHA_PDF, STONELBOX, contar, contarVisitaUmaVez, origemDaVisita, veioPelaDica } from "utils/colorir";

// 🖍️ Página da folha de colorir da Lulu e do Nando (22/10/2026): pedido do Jerônimo, com o OK do dono. É o "link na
// bio" do Reels (as mãos do dono pintando a folha) e dos stories da semana. Os pais baixam o PDF direto, sem cadastro
// nem e-mail; o código da folha leva à história "Lulu e Nando, Histórias da Bíblia, Atos 1" no YouTube da JoinKids.
// Textos do Jerônimo, sem mudar uma vírgula. A contagem está explicada em utils/colorir.

export const TITULO = 'Folha de colorir cristã grátis: Lulu e Nando | JoinKids';
export const DESCRICAO = 'Folha de colorir grátis da Lulu e do Nando para imprimir em A4, com código para assistir a uma história da Bíblia com o seu filho.';

export default function Colorir() {
  // O endereço de quando a página abriu: a dica do Instagram (filha desta tela) põe a marca "veio" no endereço antes
  // dos efeitos daqui rodarem, e a visita de dentro do app não pode contar como quem chegou pela dica.
  const [busca] = useState(() => (typeof window !== 'undefined' ? window.location.search : ''));
  const origem = origemDaVisita(busca);

  useEffect(() => {
    document.title = TITULO;
    const descricao = document.querySelector('meta[name="description"]');
    const descricaoAntes = descricao ? descricao.getAttribute('content') : null;
    if (descricao) descricao.setAttribute('content', DESCRICAO);
    return () => {
      // Ao sair, a aba volta ao título da marca, como na /tv.
      const marca = document.querySelector('meta[property="og:title"]');
      if (marca && marca.content) document.title = marca.content;
      if (descricao && descricaoAntes !== null) descricao.setAttribute('content', descricaoAntes);
    };
  }, []);

  useEffect(() => {
    // Chegou ao Chrome ou ao Safari pela dica: a marca sai do endereço (a contagem leva a informação).
    tirarMarcaDoEndereco();
    const veio = veioPelaDica(busca);
    // A visita só conta quando a página aparece de verdade na tela (o Instagram às vezes carrega antes do toque).
    if (document.visibilityState !== 'hidden') {
      contarVisitaUmaVez(origem, veio);
      return undefined;
    }
    const apareceu = () => {
      if (document.visibilityState === 'hidden') return;
      document.removeEventListener('visibilitychange', apareceu);
      contarVisitaUmaVez(origem, veio);
    };
    document.addEventListener('visibilitychange', apareceu);
    return () => document.removeEventListener('visibilitychange', apareceu);
  }, [busca, origem]);

  const baixar = () => contar('baixar', origem);

  return (
    <div className="jk-lp">
      <Cabecalho logoParaInicio foraDaInicial />

      <section className="colorir-topo">
        <div className="wrap colorir-col">
          <h1>Pinte a Lulu e o Nando</h1>
          <p className="colorir-sub">Folha de colorir grátis, para imprimir em casa ou na escolinha bíblica. Depois de pintar, aponte a câmera do celular para o código da folha e assista com o seu filho a uma história da Bíblia com a Lulu e o Nando.</p>
          <a className="colorir-folha" href={FOLHA_PDF} download={FOLHA_NOME} onClick={baixar} aria-label="Baixar a folha de colorir em PDF">
            <img src={FOLHA_IMAGEM} alt="Folha de colorir com a Lulu e o Nando acenando, uma nuvem, o sol e flores, e o código para assistir à história" width="1000" height="1413" />
          </a>
          <a className="btn btn-green colorir-baixar" href={FOLHA_PDF} download={FOLHA_NOME} onClick={baixar}>Baixar a folha (PDF)</a>
          <p className="colorir-nota">Imprima em A4. O traço é fino de propósito, para gastar pouca tinta.</p>
          <div className="colorir-dica">
            <AvisoNavegadorApp contexto="colorir" />
          </div>
        </div>
      </section>

      <section className="section cta colorir-convite">
        <div className="wrap center">
          <h2>Gostou? A Lulu e o Nando têm muito mais.</h2>
          <p className="sec-sub">Na JoinKids, são desenhos e histórias cristãs para crianças, sem anúncios. E na StonelBox da JoinKids, o seu filho ouve as histórias e, nas que têm escolhas, decide o caminho falando.</p>
          <div className="colorir-botoes">
            <a className="btn btn-green" href="/" onClick={() => contar('joinkids', origem)}>Conhecer a JoinKids</a>
            <a className="btn btn-roxo" href={STONELBOX} onClick={() => contar('stonelbox', origem)}>Conhecer a StonelBox</a>
          </div>
        </div>
      </section>

      <Rodape foraDaInicial />
    </div>
  );
}
